@if (active()) {
<div [style.width]="width()" [style.height]="height()" class="pip">
  <header class="pip__header" cdkDragHandle>
    <span class="pip__header__title">{{ title() }}</span>

    <div class="pip__header__title-container">
      <a pdsTooltip="Abrir em nova aba" pdsTooltipPosition="bottom" [routerLink]="routerOpenInNew()" (click)="close()" class="pip__header__title-container__link" target="_blank">
        <i class="icon">open_in_new</i>
      </a>
      <i pdsTooltip="Fechar" pdsTooltipPosition="bottom" class="icon pip__header__icon-close" (click)="onClose()">close</i>
    </div>
  </header>
  <main class="pip__content">
    <ng-content></ng-content>
  </main>
</div>
}
